import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import TextInput from '../../TextInput/TextInput';
import HideTextInput from '../../TextInput/HideTextInput';
import LinearLoader from "../../Loader/LinearLoader";
import './styles.css';
import UserContext from "contexts/UserContext";
import usePromoAsset from "hooks/usePromoAsset";
import useDataLayer from "hooks/useDataLayer";

function LoginForm({
    doc, setDoc, docWarning,
    password, setPassword, passwordWarning,
    onClick, dontHaveAnAccount, forgotPassword,
    loading
}) {
    const { currentPromo } = useContext(UserContext);
    const [errorMessage] = useState('');
    const navigate = useNavigate();
    const dataLayer = useDataLayer();

    const { asset: promo } = usePromoAsset(currentPromo, 'card.png');

    const handleForgotPasswordClick = () => {
        dataLayer.push({
            event: 'esqueci-senha',
        });
        navigate(`/${currentPromo.path}/esqueci-minha-senha`);
    };

    const handleForgotEmailClick = () => {
        dataLayer.push({
            event: 'esqueci-email',
        });
        navigate(`/${currentPromo.path}/esqueci-meu-email`);
    };

    return (
        <form className="login-container">
            <h1>Login</h1>
            <div className="login-card">
                <div className="login-left">
                    <img src={promo} className="promo-kv" alt="promo-kv" />
                </div>
                <div className="login-form-container">
                    <p className="login-form-title">Bem-vindo de volta</p>
                    {
                        currentPromo.status === 'active' &&
                        <p className="login-form-subtitle">Ainda não tem uma conta? <br /> <span className="create-account" onClick={dontHaveAnAccount}>Inscreva-se aqui</span></p>
                    }
                    <div className="login-form-inputs-container">
                        <TextInput
                            label={<span>Seu CPF/CNPJ ou Email</span>}
                            value={doc}
                            setValue={setDoc}
                            warningMessage={docWarning}
                        />
                        <HideTextInput
                            label={<span>Sua senha</span>}
                            value={password}
                            setValue={setPassword}
                            warningMessage={passwordWarning}
                        />
                         <div className="login-form-forgot-password-container">
                         <span className="forgot-text" onClick={handleForgotPasswordClick}>Esqueceu sua senha? Clique aqui</span>
                        </div>
                        <div className="login-form-forgot-password-container">
                        <span className="forgot-text" onClick={handleForgotEmailClick}> Esqueceu seu email? Clique aqui</span>
                        </div>

                    </div>
                    <button type="submit" className="login-form-button" onClick={onClick}>
                        {
                            loading ? <LinearLoader white /> : <p>Entrar</p>
                        }
                    </button>
                    {errorMessage && (
                        <div className="login-form-error-message">
                            <p>{errorMessage}</p>
                        </div>
                    )}
                </div>
            </div>
        </form>
    );
}

export default LoginForm;
